import { ApiError } from './client'

/** Traduce un fallo a algo que la estación pueda accionar. */
export function messageFor(err: unknown, what = 'tus incidencias'): string {
  if (err instanceof ApiError) {
    if (err.status === 401)
      return 'Tu sesión expiró. Vuelve a abrir el portal desde Cotalker para continuar.'
    if (err.status === 403) return 'Tu usuario no tiene acceso a esta información.'
    if (err.status === 0) return 'No hay conexión con Cotalker. Revisa tu red e inténtalo de nuevo.'
    return `Cotalker respondió con un error (${err.status}).`
  }
  return `Algo salió mal al cargar ${what}.`
}
